import React, {MouseEvent, useState} from 'react';
import {Control} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import Unblock from 'shared/ui/icons/General/Unblock';
import Hide from 'shared/ui/icons/General/Hide';
import Show from 'shared/ui/icons/General/Show';

import {PALETTE} from 'shared/config/model/palette';

import IconButton from '../IconButton/IconButton';

import Input, {InputProps} from './Input';
import {getInputClassName, InputStateIcon, useInputState} from './inputState';

import styles from './Input.module.scss';

type InputPasswordProps = Omit<InputProps, 'type' >;

interface IInputPasswordProps extends InputPasswordProps {
    control: Control<any>;
    validate?: boolean;
}

const InputPassword: React.FC<IInputPasswordProps> = ({ control, validate = true, ...rest }) => {
    const [isVisible, setIsVisible] = useState(false);

    const {state} = useInputState({control, name: rest.name ?? 'password', validate});

    const toggleVisibility = (event: MouseEvent) => {
        event.preventDefault();
        setIsVisible((prev) => !prev);
    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };

    return (
        <div className={styles.input_container}>
            <div className={styles.icon}>
                <InputStateIcon state={state} defaultIcon={<Unblock/>}/>
            </div>

            <Input
                type={isVisible ? 'text' : 'password'}
                name="password"
                placeholder={t`Пароль`}
                className={getInputClassName(styles, state, true)}
                onKeyDown={handleKeyDown}
                rules={{
                    minLength: {
                        value: 8,
                        message: t`Не менее 8 символов`,
                    },
                    required: t`Необходимо ввести пароль`,
                }}
                {...rest}
            />
            <IconButton
                className={styles.eye}
                onClick={toggleVisibility}
                onKeyDown={handleKeyDown}
                title={isVisible ? t`Скрыть пароль` : t`Показать пароль`}
                tabIndex={-1}
                role="button"
                icon={isVisible ? <Show color={PALETTE.neutral}/> : <Hide color={PALETTE.neutral}/>}
            />
        </div>
    );
};

export default InputPassword;